import { Operand, SpecificationListItem } from 'api';
import { formatNumber } from 'ui';

import { formatInstructionComparisonOperator } from '../formatInstructionComparisonOperator/formatInstructionComparisonOperator';

export type InstructionWarning = {
  text?: string;
  highlight: boolean;
};

export const formatInstructionWarning = (
  operand: Operand,
  instructions?: SpecificationListItem[]
): InstructionWarning | undefined => {
  const found = instructions?.find((instruction) => instruction.operands.includes(operand));
  if (!found) {
    return undefined;
  }
  if (found.spec_comparison_operator == null || found.spec_threshold_value == null) {
    return undefined;
  }
  const isMultiOperand = found.operands.length > 1;
  const percent = formatNumber(found.spec_threshold_value * 100, {
    maximumFractionDigits: 2,
    style: 'percent',
  });
  const operator = formatInstructionComparisonOperator(found.spec_comparison_operator, 'long');
  return {
    highlight: true,
    text: isMultiOperand ? undefined : `${operator} ${percent}`,
  };
};
